import { Injectable } from '@angular/core';
import { AbstractControl, ValidationErrors } from '@angular/forms';
import * as lodash from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor() { }

  public isNullOrUndefined(value: any): boolean {
    return value === null || value === undefined;
  }

  public nonNullAndNonUndefined(value: any): boolean {
    return value !== null && value !== undefined;
  }

  static controlCharactersValidator(control: AbstractControl): ValidationErrors | null {
    const value = control.value;
    if (value.contains('\n') ||
      value.contains('\r') ||
      value.contains('\t')) {
      return { hasControlCharacters: true };
    }
  }

  static counterIndexValueValidator(control: AbstractControl): ValidationErrors | null {
    let hasCounterIndexValueFromatError: boolean = false;
    let hasCounterIndexBigIntError: boolean = false;
    const counterIndexValue = control.value;
    if (counterIndexValue?.includes("|")) {
      let list = counterIndexValue.split("|");
      list.forEach((el: string) => {
        let cadran = el.split(":");
        if (cadran.length != 2) {
          hasCounterIndexValueFromatError = true;
        }
        if (!UtilService.isNumeric(cadran[1])) {
          hasCounterIndexBigIntError = true;
        }
      });
      let errors = hasCounterIndexValueFromatError ? { counterIndexValueFormat: true } : null
        || hasCounterIndexBigIntError ? { counterIndexValueBigInt: true } : null;
      return errors;
    }
    else {
      let errors = !UtilService.isNumeric(counterIndexValue) ?
        { counterIndexValueBigInt: true } : null;
      return errors;
    }
  }

  static isNumeric(number: any): boolean {
    return !isNaN(number) &&
      !isNaN(parseFloat(number))
  }

  static safeToString(value: any) {
    const str = lodash.toString(value);
    return str === "null" ? "" : str;
  }

}
